/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import FilterAndSortBarWithSelectAll from '@/components/listings/FilterAndSortBarWithSelectAll'
import { createId } from '@/utils/general'
import SelectAssetDefaultTable from '@/components/tables/SelectAssetDefaultTable'
import ItemsListWithToggleLayout from '@/components/wrappers/general/ItemsListWithToggleLayout'
import CircleLoader from '@/components/loaders/CircleLoader'

const ItemSelector = ({
  customTable,
  filterOptions,
  getItemsPropsForTable,
  isSelected,
  itemComponent: ItemComponent,
  items,
  itemsLayout,
  loading,
  onChangePage,
  onFilterResults,
  onReset,
  page,
  searchParams,
  searchResultsKeyData,
  searchResultsKeyLabel,
  searchResultsKeyValue,
  selectAll,
  setItemCustomProps,
  sortOptions = [],
  tableColumns,
  toggleSelectAll,
  toggleSelection,
  totalItems,
  totalPages
}) => {
  const CustomTable = customTable || SelectAssetDefaultTable
  const cards = items?.map(item => {
    const itemProps = setItemCustomProps(item)

    return (
      <ItemComponent
        {...itemProps}
        key={createId()}
        isSelected={isSelected}
        toggleSelection={toggleSelection}
      />
    )
  })

  const table = tableColumns
    ? <CustomTable
        columns={tableColumns}
        getItemProps={getItemsPropsForTable}
        isSelected={isSelected}
        items={items}
        toggleSelection={toggleSelection}
      />
    : undefined

  if (loading) {
    return <CircleLoader />
  }

  return (
    <ItemsListWithToggleLayout
      cards={cards}
      currentPage={page}
      header={
        <FilterAndSortBarWithSelectAll
          className="mb-2"
          currentValues={searchParams}
          filterOptions={filterOptions}
          onFilterResults={onFilterResults}
          onReset={onReset}
          searchResultsKeyData={searchResultsKeyData}
          searchResultsKeyLabel={searchResultsKeyLabel}
          searchResultsKeyValue={searchResultsKeyValue}
          selectAll={selectAll}
          sortOptions={sortOptions}
          toggleSelectAll={toggleSelectAll}
        />
      }
      itemsLayout={itemsLayout}
      onChangePage={onChangePage}
      searchParams={searchParams}
      table={table}
      totalItems={totalItems}
      totalPages={totalPages}
    />
  )
}

export default ItemSelector
